import IconLoader from "@/components/IconLoader";
import SmartSearchInput from "@/components/SmartSearch/SmartSearchInput";
import { SmartSearchProvider } from "@/contexts/useSmartSearch";
import { useTranslation } from "@/i18n/client";
import color from "@/styles/color";
import { InputAdornment } from "@mui/material";

const WantToBuySearchInput = () => {
  const { t } = useTranslation();
  return (
    <SmartSearchProvider>
      <SmartSearchInput
        fullWidth
        size="medium"
        placeholder={t("W2B.filter.search-placeholder")}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <IconLoader
                iconName="SearchIcon"
                sx={{ fontSize: { xs: "16px" }, color: color.gray400 }}
              />
            </InputAdornment>
          ),
          sx: {
            display: "flex",
            alignItems: "center",
            height: "40px",
            padding: "16px 24px 16px 24px",
            gap: "8px",
            fontWeight: 600,
          },
        }}
        sx={{
          borderRadius: { xs: "8px", lg: "60px" },
          backgroundColor: { xs: color.white, lg: color.formField },
          fontSize: { xs: "12px", sm: "14px" },
          "& input::placeholder": {
            fontSize: { xs: "11.75px", sm: "14px" },
          },
          "& fieldset": { border: "none" },
        }}
        resultContainerSx={{
          backgroundColor: { xs: color.white, lg: color.formField },
        }}
      />
    </SmartSearchProvider>
  );
};

export default WantToBuySearchInput;
